import { render, staticRenderFns } from "./distrito.vue?vue&type=template&id=ee4185f8&"
import script from "./distrito.vue?vue&type=script&lang=js&"
export * from "./distrito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports